import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CsvUpload } from '../../../models/csv-import.model';
import { CsvColumnMappingComponent } from '../csv-column-mapping/csv-column-mapping.component';
import { AlertService } from '../../../../core/alert.service';
import { CsvImportService } from '../../../services/csv-import.service';

@Component({
  selector: 'app-csv-import-wizard',
  templateUrl: './csv-import-wizard-component.html',
  styleUrls: ['./csv-import-wizard-component.scss'],
})
export class CsvImportWizardComponent implements OnInit {
  busy: boolean = false;
  @Input() type: string = ''; // [item,customer,invoice]

  uploadtype: number = 1;
  uploadStep: number = 2;
  processingFile: boolean = false;
  hasUploadError: boolean = false;
  uploadMessage: string = '';
  response: any;
  headerRowIndex: number = 1;
  noRowHeader: boolean = false;

  public csvContent: string;
  public fileContent: string;
  constructor(
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private csvImportService: CsvImportService,
    private alert: AlertService
  ) {}

  ngOnInit() {}

  selectOption(uploadtype: number) {
    this.uploadtype = uploadtype;
  }

  step() {
    this.uploadStep = this.uploadStep == 1 ? 2 : 1;
  }

  openFileBrowser() {
    let element: HTMLElement = document.getElementById(
      'csvFile'
    ) as HTMLElement;
    element.click();
  }

  onCsvFileSelected(event: any) {
    let files = event.target.files;
    this.processingFile = true;
    var self = this;
    var file = files[0];
    const formData = new FormData();
    formData.append(file.name, file);
    this.csvImportService
      .validateCsv(formData, this.type, this.headerRowIndex - 1)
      .subscribe(
        (res) => {
          this.response = res;
          this.processingFile = false;
          if (this.response.Code == 200) {
            let csvUpload = new CsvUpload();
            csvUpload.UploadType = this.uploadtype;
            csvUpload.Items = this.response.Data;
            if (this.response.IsNonDefault == true) {
              this.onFileLoad(csvUpload.Items, this.response.Id);
              self.activeModal.close();
            } else {
              self.activeModal.close(csvUpload);
            }
          } else {
            self.activeModal.close();
            this.hasUploadError = true;
            this.uploadMessage = this.response.Message;
          }
        },
        (error: any) => {
          this.alert.alertWarning({
            title: 'CSV Upload',
            text: 'File upload error.',
          });
          self.activeModal.close();
        }
      );
    /*setTimeout(function () {
      self.activeModal.close();
    }, 3000);*/
  }

  onFileLoad(fileLoadedEvent, csvFileId) {
    this.csvContent = fileLoadedEvent;
    let modal = this.modalService.open(CsvColumnMappingComponent, {
      size: 'xl',
      backdrop: 'static',
    });
    modal.componentInstance.type = this.type;
    modal.componentInstance.csvData = {
      csvContent: this.csvContent,
      csvID: csvFileId,
      headerRowIndex: this.headerRowIndex - 1,
    };
  }

  hasHeaderChange(event: any) {
    if (event.target.checked) {
      this.headerRowIndex = 0;
    }
  }

  headerRowChanged(event: any) {
    this.headerRowIndex = event.target.value;
  }

  close() {
    this.activeModal.close();
  }

  getHowToLink() {
    switch (this.type) {
      case 'invoice':
        return 'https://support.heartlandforserviceprofessionals.com/article/80-import-invoices';
        break;
      case 'item':
        return 'https://support.heartlandforserviceprofessionals.com/article/73-import-products';
        break;
      case 'customer':
        return 'https://support.paymentsmanagerplus.com/hc/en-us/articles/25964495802893-Import-Customers-Using-Default-Template';
        break;
    }
  }
}
